import { createAsyncThunk } from '@reduxjs/toolkit';

export type ThunkTypes = {
  state: RootState;
  dispatch: AppDispatch;
  rejectValue: unknown;
  extra: unknown;
};
export const createAppAsyncThunk = createAsyncThunk.withTypes<ThunkTypes>();
